import { FC } from "react";

import { Grid, Tooltip } from "@mui/material";

import EventSelect from "../../../common/components/select/EventSelect/EventSelect";
import LocationSelect from "../../../common/components/select/LocationSelect/LocationSelect";
import {
  selectedLocationVariable,
  useSelectedLocation,
} from "../../../common/variables/selectedLocation";
import {
  selectedModelVariable,
  useSelectedModel,
} from "../../../common/variables/selectedModel";

const RecentActivitiesFilters: FC = () => {
  const selectedModel = useSelectedModel();
  const setSelectedModel = selectedModelVariable;

  const selectedLocation = useSelectedLocation();
  const setSelectedLocation = selectedLocationVariable;

  const isModelActive = selectedModel !== null;
  const isLocationActive = selectedLocation !== null;

  const handleModelChange = (value: string | null) => {
    setSelectedModel(value);

    if (value !== null) {
      setSelectedLocation(null);
    }
  };

  const handleLocationChange = (value: string | null) => {
    setSelectedLocation(value);

    if (value !== null) {
      setSelectedModel(null);
    }
  };

  return (
    <Grid item xs={12} sm={6} display="flex" gap="16px">
      <Tooltip
        title={isModelActive ? "Clear model filter to use location filter" : ""}
        disableHoverListener={!isModelActive}
      >
        <div style={{ flex: 1 }}>
          <LocationSelect
            value={selectedLocation}
            onChange={handleLocationChange}
            disabled={isModelActive}
          />
        </div>
      </Tooltip>

      <Tooltip
        title={
          isLocationActive ? "Clear location filter to use model filter" : ""
        }
        disableHoverListener={!isLocationActive}
      >
        <div style={{ flex: 1 }}>
          <EventSelect
            value={selectedModel}
            onChange={handleModelChange}
            disabled={isLocationActive}
          />
        </div>
      </Tooltip>
    </Grid>
  );
};

export default RecentActivitiesFilters;
